// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__NYEfZ","upload":"Small_upload__36qQA","imageWrap":"Small_imageWrap__2887m","removeBtn":"Small_removeBtn__j3jve"};